
import { getReputationLevel, ReputationLevel } from '../../mocks/badges'

interface ReputationLevelBadgeProps {
  points: number
  size?: 'xs' | 'sm' | 'md'
  showPoints?: boolean
}

export const ReputationLevelBadge = ({ points, size = 'sm', showPoints = false }: ReputationLevelBadgeProps) => {
  const level: ReputationLevel = getReputationLevel(points)

  const sizeClasses = {
    xs: 'text-[10px] px-1.5 py-0.5 gap-1',
    sm: 'text-xs px-2 py-0.5 gap-1',
    md: 'text-sm px-2.5 py-1 gap-1.5',
  }

  const iconSizes = {
    xs: 'text-[10px]',
    sm: 'text-xs',
    md: 'text-sm',
  }

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClasses[size]} ${level.bgColor} ${level.color}`}>
      <i className={`${level.icon} ${iconSizes[size]}`}></i>
      <span>{level.name}</span>
      {showPoints && <span className="opacity-70">({points})</span>}
    </span>
  )
}

export default ReputationLevelBadge
